import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '6',
  label: 'Core Teaching Volumes'
}, {
  value: '5',
  label: 'Professional Teacher Bonuses'
}, {
  value: 'K–12',
  label: 'Elementary · Middle · High'
}, {
  value: '⚡',
  label: 'Instant Digital Access'
}];
export function Hero() {
  return <section className="w-full bg-navy px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-101" data-mp="4mrtszj81xkp">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-102" data-mp="12a0kd8y2xwtk">
        <span className="mb-6 inline-block rounded-full border border-gold bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-gold" data-id="element-103" data-mp="xae5yw6imaj6">
          For Visual Arts Teachers
        </span>
        <h1 className="font-display text-[24px] font-bold leading-tight text-white sm:text-5xl md:text-6xl" data-id="element-104" data-mp="ncq13df73mna">
          Your Entire Art Year—Organized and Ready to Teach.
        </h1>
        <figure className="relative mt-8 w-full max-w-[680px] sm:mt-10" data-id="element-105" data-mp="382fgbrjt9agi">
          <div className="relative overflow-hidden rounded-[26px] bg-navy-mid shadow-[0_20px_45px_-22px_rgba(0,0,0,0.8)]" data-id="element-106" data-mp="3814e3w60kari">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/0d79c4bc-350d-4ed7-94ee-1bb669a020d0.jpg" alt="The Complete Art Year system: the six core volumes — Elements of Art, Drawing & Illustration, Color, Painting & Mixed Media, Principles of Design, Art, Artists & Visual Cultures, and Art Projects & Creative Challenges — shown alongside a lesson open on a tablet" width="680" height="382" loading="eager" decoding="sync" className="block aspect-[16/9] w-full object-cover" data-id="element-107" data-mp="3o7lqxnqt30nd" />
            <div className="pointer-events-none absolute inset-0 rounded-[26px] ring-1 ring-inset ring-gold/55" aria-hidden="true" data-id="element-108" data-mp="2viol4k3s6wbi" />
          </div>
          <figcaption className="px-3 pt-3 text-center text-xs font-medium text-white/75" data-id="element-109" data-mp="2lkqyg11kl7l0">
            THE COMPLETE ART YEAR™ — the six core volumes, ready for your next class.
          </figcaption>
        </figure>
        <p className="mt-6 max-w-xl text-[12px] text-white/75 sm:text-base" data-id="element-110" data-mp="nat7pcgomml8">
          A complete visual teaching system with lessons, activities, creative projects, art history,
          assessment tools and classroom resources—all designed to help you spend less time building
          everything from scratch.
        </p>
        <p className="mt-4 text-[13px] font-semibold text-white sm:text-base" data-id="element-111" data-mp="1azui3592s7t5">
          6 Core Teaching Volumes + 5 Professional Teacher Bonuses
        </p>
        <div className="mt-8 w-full max-w-md" data-id="element-112" data-mp="112pv537eo8ba">
          <CTAButton label="GET THE COMPLETE ART YEAR™" data-id="element-113" data-mp="111eql164ywj4" />
          <p className="mt-3 text-xs text-white/65 sm:text-sm" data-id="element-114" data-mp="x1edpkyoqte6">
            One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
          </p>
          <p className="mt-2 text-xs font-medium text-gold" data-id="element-115" data-mp="3lqugltxj6h7p">
            Elementary · Middle School · High School
          </p>
        </div>
        <div className="mt-7 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-gold bg-steel sm:mt-9 sm:grid-cols-4" data-id="element-116" data-mp="1x9ukg9uwtbmw">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-4 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l border-gold/45' : ''} ${index >= 2 ? 'border-t border-gold/45' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-117" data-mp="269zfdkix2hk6" data-mpi={index}>
              <span className="font-display text-4xl font-bold text-gold" data-id="element-118" data-mp="2kydtirls9sg1">{metric.value}</span>
              <span className="mt-1 text-xs font-semibold text-white sm:text-sm" data-id="element-119" data-mp="2ozz3a430tqm0">
                {metric.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}